import { type Guard, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useCallback, useMemo } from 'react';

export const useThirdPartyTopUpGuard: Guard = () => {
	const { replace } = useRouter();
	const {
		areSettingsLoading,
		settings: { isThirdPartyTopUpEnabled }
	} = useSettings();

	const status = useMemo(() => {
		if (areSettingsLoading) return 'loading';
		if (!isThirdPartyTopUpEnabled) return 'denied';

		return 'allowed';
	}, [areSettingsLoading, isThirdPartyTopUpEnabled]);

	const onDenied = useCallback(() => replace('/nc-wallet'), [replace]);

	return {
		onDenied,
		status
	};
};
